enum EPayloadProperties {
    GRANT_TYPE = 'grant_type',
    MEDIUM_WWW = 'mediumWww',
    SESSION_ID_WWW = 'sessionIdWww',
    ACCESS_TOKEN = 'access_token',
}

export default EPayloadProperties
